const CONSTANTS = {
  GET_ANNOUNCEMENTS_ENDPOINT: "GET_ANNOUNCEMENTS_ENDPOINT",
  GET_ANNOUNCEMENTS: "GET_ANNOUNCEMENTS",
  GET_ANNOUNCEMENTS_SUCCESS: "GET_ANNOUNCEMENTS_SUCCESS",
  GET_ANNOUNCEMENTS_FAILURE: "GET_ANNOUNCEMENTS_FAILURE",
  GET_ANNOUNCEMENTS_LOADER: "GET_ANNOUNCEMENTS_LOADER",

  //Reducer

  SET_ANNOUNCEMENTS_LIST: "SET_ANNOUNCEMENTS_LIST",
  SET_ANNOUNCEMENTS_LIST_LOADER: "SET_ANNOUNCEMENTS_LIST_LOADER",
  SET_ANNOUNCEMENTS_LIST_SUCCESS: "SET_ANNOUNCEMENTS_LIST_SUCCESS",
  SET_ANNOUNCEMENTS_LIST_FAILURE: "SET_ANNOUNCEMENTS_LIST_FAILURE",

  SET_ANNOUNCEMENTS_ATTACHED_LIST: "SET_ANNOUNCEMENTS_ATTACHED_LIST",
  CLEAR_CURRENT_ANNOUNCEMENTS_ATTACHED_LIST:
    "CLEAR_CURRENT_ANNOUNCEMENTS_ATTACHED_LIST",
};
export const CONTENT_LIMIT = 20;
export default CONSTANTS;
